window.angular.module('hippo').service('apiService', function ($http, AsyncLockService, featureToggle) {
    'ngInject';
    const apiHost = featureToggle.getApiHost();
    const apiVersion = featureToggle.getApiVersion();
    const serverLockName = 'serverLock';
    const _ = window._;

    this.validateInvitationCode = (invitationCode, deviceId) => {
        return $http.get(`${apiHost}/${apiVersion}/code/${invitationCode}/${deviceId}`);
    };

    function testUrl(relUrl) {
        return `${featureToggle.getApiHost()}/${relUrl}`;
    }

    this.test = {
        error: {
            list: () => $http.get(testUrl('test/error')),
            get: (errorId) => $http.get(testUrl(`test/error/${errorId}`))
        }
    };

    this.getYotpoTotalReviewsAndAverageScore = () => {
        return $http.get(`https://api.yotpo.com/products/${window.hippoConfig.yotpoKey}/yotpo_site_reviews/bottomline`);
    };

    // this is only for internal statistics, please use window.analytics.track
    // TODO: remove when we do followup tracking removal work
    this.internalTracking = (eventData, opts = {}) => {
        // return this._post(`${apiHost}/${apiVersion}/track`, eventData, opts);
        return Promise.resolve();
    };

    this.sendComcastEmailEvent = (eventData) => {
        this._post(`${apiHost}/${apiVersion}/comcastEvent`, eventData);
    };

    this.subscribe = (email) => {
        return $http({
            method: 'POST',
            url: 'https://api.kickofflabs.com/v1/67883/subscribe',
            data: `email='${email}'`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    };

    // todo: remove these wrappers, use interceptor instead
    this._get = (url) => {
        return $http.get(url, {
            withCredentials: true,
            headers: {
                'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT', // IE cache bug fix, doing it here so that Smartystreets isn't affected
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache'
            }
        });
    };

    this._post = (url, data, opts) => {
        opts = _.merge(opts || {}, { withCredentials: true });
        return $http.post(url, data, opts);
    };

    // Customer approval Id
    this.customerApproval = {
        getCustomerApproval: (approvalId, getSmartHomeDiscount) => {
            let baseURL = `${apiHost}/${apiVersion}/approval/${approvalId}`;
            if (getSmartHomeDiscount) {
                baseURL += '?calculateDiscount=true';
            }
            return this._get(baseURL);
        },
        updateCustomerApproval: (approvalId, approvalData) => {
            return this._post(`${apiHost}/${apiVersion}/approval/${approvalId}`, approvalData);
        }
    };

    this.cancellationAssist = {
        get: (cancellationId) => {
            return this._get(`${apiHost}/${apiVersion}/cancellation_assist/${cancellationId}`);
        },
        update: (cancellationId, cancellationData) => {
            return AsyncLockService.lockPromise(serverLockName, () => {
                return this._post(`${apiHost}/${apiVersion}/cancellation_assist/${cancellationId}`, cancellationData);
            });
        },
        carriers: () => {
            return this._get(`${apiHost}/${apiVersion}/cancellation_assist/carriers`);
        }
    };

    this.policy = {
        updateMortgageLenders: (id, type, lenders, suppressLenderEmail) => {
            return this._post(`${apiHost}/${apiVersion}/lender/update`, {
                lenders,
                id,
                type,
                suppress_lender_email: suppressLenderEmail
            });
        }
    };

    this.builder = {
        getCommunites: (organizationId, state) => {
            return this._get(`${apiHost}/${apiVersion}/communities/${state}?organization_id=${organizationId}`);
        },
        getModels: (organizationId, communityId) => {
            return this._get(
                `${apiHost}/${apiVersion}/communities/models/${communityId}?organization_id=${organizationId}`
            );
        }
    };

    this.getVeriskToken = (leadId) => {
        return this._get(`${apiHost}/${apiVersion}/lead/${leadId}/rce/auth-token`);
    };

    /**
     * @deprecated This API call has been deprecated, and no longer supports on the BE;
     */
    this.reloadVeriskValuationReport = (leadId) => {
        // deprecated;
        return this._post(`${apiHost}/${apiVersion}/lead/${leadId}/rce/reload`);
    };

    // when this gets too big, lets move to separate file
    this.lead = {
        getLead: (leadId) => {
            return this._get(`${apiHost}/${apiVersion}/lead/${leadId}`);
        },
        bind: (leadId, data) => {
            // HIP-27935: Help identify where a lead flow originated from.
            data.lead_flow_used = 'angular';
            return AsyncLockService.lockPromise(serverLockName, () => {
                return this._post(`${apiHost}/${apiVersion}/lead/${leadId}/bind`, data);
            });
        },
        prefillAddress: (data) => {
            return this._post(`${apiHost}/${apiVersion}/address`, data);
        },
        createLead: (data) => {
            // HIP-27935: Help identify where a lead flow originated from.
            data.lead_flow_used = 'angular';
            return this._post(`${apiHost}/${apiVersion}/lead`, data);
        },
        postLead: (leadId, data) => {
            // HIP-27935: Help identify where a lead flow originated from.
            // This is useful in the case where we are redirected to angular from the react lead flow.
            data.lead_flow_used = 'angular';
            return AsyncLockService.lockPromise(serverLockName, () => {
                return this._post(`${apiHost}/${apiVersion}/lead/${leadId}`, data);
            });
        },

        getQuickQuote: (leadId) => {
            return this._get(`${apiHost}/${apiVersion}/lead/${leadId}/quote/quick`);
        },

        getFullQuote: (leadId) => {
            return this._get(`${apiHost}/${apiVersion}/lead/${leadId}/quote/full`);
        },

        getCustomer: (customerId, token) => {
            return this._get(`${apiHost}/${apiVersion}/customer/${customerId}/${token}`);
        },

        getHistory: (leadId) => {
            return this._get(`${apiHost}/${apiVersion}/lead/${leadId}/history`);
        },
        /**
         *
         * @param leadId
         * @param data
         * @returns {HttpPromise}
         */
        validate: (leadId, data, opts) => {
            return this._post(`${apiHost}/${apiVersion}/lead/${leadId}/validate`, data, opts || {});
        },

        getDownloadQuoteUrl: (leadId) => {
            return `${apiHost}/${apiVersion}/lead/${leadId}/docs/quote?redirect=true`;
        },

        getProducerUrl: (producerId) => {
            return this._get(`${apiHost}/${apiVersion}/lead/producerurl?producer_id=${producerId}`);
        },

        getRceDocumentUrl: (leadId) => {
            return this._get(`${apiHost}/${apiVersion}/lead/${leadId}/docs/rce_document`);
        },

        getSmartHomeDiscount: (leadId) => {
            return this._get(
                `${apiHost}/${apiVersion}/lead/${leadId}/calculate_discount?field=property_data.smart_home_kit_activated`
            );
        },

        getSocialData: (leadData) => {
            return this._post(`${apiHost}/${apiVersion}/social`, leadData);
        },

        getSimplisafeSmartHomeDiscount: (leadId, discount) => {
            let value = discount;
            if (Array.isArray(discount)) {
                value = discount.join(',');
            }
            return this._get(`${apiHost}/${apiVersion}/lead/${leadId}/calculate_discount?field=${value}`);
        },

        postSmartHomeProMonitoring: (leadId, key) => {
            return AsyncLockService.lockPromise(serverLockName, () => {
                return this._post(`${apiHost}/${apiVersion}/lead/${leadId}/smart-home-pro-monitoring`, {
                    key
                });
            });
        },

        getSmartHomeProMonitoringEmail: (leadId) => {
            return this._get(`${apiHost}/${apiVersion}/lead/${leadId}/smart-home-pro-monitoring/email`);
        },

        getPhotoUploadEmail: (leadId) => {
            return this._get(`${apiHost}/${apiVersion}/lead/${leadId}/photo-upload-email`);
        },
        getProgressiveAutoInsuranceLink: (leadId) => {
            return this._get(`${apiHost}/${apiVersion}/lead/${leadId}/progressive`);
        },

        getApplicationDocumentLink: (leadId) =>
            `${apiHost}/${apiVersion}/lead/${leadId}/docs/app_document/?redirect=true`
    };
});
